// @owners { team: patients }
import { type StateBiometrics } from '~shared/reducers/biometrics';
import { type ReduxStateShared } from '~shared/types';

export const getBiometrics = (state: ReduxStateShared): StateBiometrics => state.biometrics;
